import axios from "axios";
import VPagination from "@hennge/vue3-pagination";
import store from "@/store";

export default {
  name: "StudyPhaseManagement",
  components: {
    VPagination,
  },
  data() {
    return {
      studyPhases: [],
      editIndex: null,
      editableRow: null,
      protocolId: "",
      idToken: "",
      pageindex: 1,
      pageSize: 10,
      SortProperty: "name",
      sortorder: 0,
      totalPages: 1,
      totalCount: 0,
      currentPage: 1,
      loadNextPage: false,
      baseurl: process.env.VUE_APP_Service_URL,
      validationErrors: {},
      isAddingNew: false,
      newRow: {
        name: "",
        type: "",
        active: true,
        description: "",
      },
      newRowErrors: {},

      protocol: {},
    };
  },
  async mounted() {
    this.idToken = store.getters.getIdToken;
    this.protocolId = this.$route.query.id;

    await this.getProtocolbyId();
    if (this.protocolId) {
      await this.listStudyPhases(this.protocolId);
    }
  },
  methods: {
    async listStudyPhases(protocolId) {
      await axios
        .get(
          `${this.baseurl}/management/studyprotocol/listdastudyphases?protocolId=${this.protocolId}&pageindex=${this.pageindex}&pagesize=${this.pageSize}&SortProperty=${this.SortProperty}&SortOrder=${this.sortorder}`,
          {
            headers: {
              Authorization: "Bearer " + this.idToken,
              "Content-Type": "application/json",
            },
          }
        )
        .then((res) => {
          this.studyPhases = res.data.results;
          this.totalCount = res.data.totalCount;
          this.totalPages = Math.ceil(res.data.totalCount / this.pageSize);
        })
        .catch((err) => console.log("Error in fetching study phases:", err));
    },
    editRow(index, phase) {
      this.editIndex = index;
      this.editableRow = { ...phase };
      this.validationErrors = {};
    },
    validateRow() {
      this.validationErrors = {};
      if (!this.editableRow.name) {
        this.validationErrors.name = "Name is required.";
      }
   
      return Object.keys(this.validationErrors).length === 0;
    },
    async updateRow(daStudyPhaseId) {
      try {
        if (!this.editableRow) {
          console.error("No editable row found.");
          return;
        }

        if (!this.validateRow()) {
          return;
        }

        const updateData = {
          daStudyPhaseId: daStudyPhaseId,
          protocolRefId: this.protocolId,
          studyId: this.protocol.studyId, 
          name: this.editableRow.name,
          type: this.editableRow.type,
          active: this.editableRow.active,
          description: this.editableRow.description,
        };

        const response = await axios.put(
          `${this.baseurl}/management/studyprotocol/updatedastudyphase`,
          updateData,
          {
            headers: {
              Authorization: `Bearer ${this.idToken}`,
              "Content-Type": "application/json",
            },
          }
        );

        console.log("Update response:", response.data);

        await this.getProtocolbyId();
        this.cancelEdit();
        await this.listStudyPhases(this.protocolId);

        alert("Study Phase details updated successfully.");
      } catch (err) {
        console.error("Error during updateRow API call:", err);
        alert("Failed to update study phase. Please try again.");
      }
    },
    cancelEdit() {
      this.editIndex = null;
      this.editableRow = null;
    },
    clearFieldError(fieldName) {
      if (this.validationErrors[fieldName]) {
        delete this.validationErrors[fieldName];
      }
    },
    async loadPage(page) {
      this.currentPage = page;
      this.pageindex = page;
      this.loadNextPage = true;
      await this.listStudyPhases(this.protocolId);
    },
    async deleteRow(phaseId) {
      try {
        const confirmation = confirm("Are you sure you want to delete this study phase?");
        if (!confirmation) return;

        const response = await axios.delete(
          `${this.baseurl}/management/studyprotocol/deletebyid?collectionName=DaScrape_StudyPhase&id=${phaseId}`,
          {
            headers: {
              Authorization: `Bearer ${this.idToken}`,
              "Content-Type": "application/json",
            },
          }
        );
        console.log("Delete response:", response.data);
        await this.listStudyPhases(this.protocolId);
        if (this.studyPhases.length === 0 && this.currentPage > 1) {
          this.currentPage--;
          this.pageindex = this.currentPage;
          await this.listStudyPhases(this.protocolId);
        }
        alert("Study Phase deleted successfully.");
      } catch (error) {
        console.error("Error during study phase delete API call:", error);
        alert("Failed to delete the study phase. Please try again.");
      }
    },
    async getProtocolbyId() {
      const token = store.getters.getIdToken;
      await axios
        .get(
          `${this.baseurl}/management/document/getprotocolbyid?protocolId=${this.protocolId}`,
          {
            headers: {
              Authorization: "Bearer " + token,
              "Content-Type": "application/json",
            },
          }
        )
        .then((res) => {
          this.protocol = res.data;
        })
        .catch((err) => console.log("error in get protocol by id", err));
    },
    addNewRow() {
      this.isAddingNew = true;
      this.newRow = {
        name: "",
        type: "",
        active: true,
        description: "",
      };
      this.newRowErrors = {};
      // Cancel any active inline edit
      this.editIndex = null;
      this.editableRow = null;
    },

    cancelNewRow() {
      this.isAddingNew = false;
      this.newRowErrors = {};
    },

    clearNewFieldError(fieldName) {
      if (this.newRowErrors[fieldName]) {
        delete this.newRowErrors[fieldName];
      }
    },

    validateNewRow() {
      this.newRowErrors = {};
      if (!this.newRow.name) {
        this.newRowErrors.name = "Name is required.";
      }
      return Object.keys(this.newRowErrors).length === 0;
    },

    async saveNewRow() {
      if (!this.validateNewRow()) return;

      try {
        const payload = {
          collectionName: "DaScrape_StudyPhase",
          data: {
            protocolRefId: this.protocolId,
            studyId: this.protocol.studyId,
            name: this.newRow.name,
            type: this.newRow.type,
            active: this.newRow.active,
            description: this.newRow.description,
          },
        };

        await axios.post(
          `${this.baseurl}/management/studyprotocol/genericinsert`,
          payload,
          {
            headers: {
              Authorization: `Bearer ${this.idToken}`,
              "Content-Type": "application/json",
            },
          }
        );

        this.isAddingNew = false;
        this.newRowErrors = {};

        await this.listStudyPhases(this.protocolId);

        alert("Study Phase created successfully.");
      } catch (err) {
        console.error("Error creating study phase:", err);
        alert("Failed to create study phase. Please try again.");
      }
    }
  },
};